'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useInitialize, useTheme } from '../../hooks';
import { Card, Stack } from '@mui/material';
import { fetchImprint } from '../../api/imprint/fetchImprintText';
import { Localized } from '../../types';
import NotFound from '../../app/[locale]/(digitalHub)/not-found';
import { Column, HeadlineSmall } from '../../styles';

const ImprintScreen = () => {
    const theme = useTheme();
    const locale = useLocale();
    const [imprint, setImprint] = useState<Localized | null>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    useInitialize(() => {
        fetchImprint()
            .then((response) => {
                setImprint(response.imprint);
                setHasError(response.error !== undefined);
            })
            .catch((error) => {
                console.error(error);
            });
    });

    if (hasError) return <NotFound />;
    if (!imprint) return null;
    const content = imprint[locale] ?? '';

    return (
        <Stack spacing={theme.spacing(3)} pb={4}>
            <Card sx={{ px: 3, py: 1 }}>
                <Column gap={3}>
                    <HeadlineSmall color='primary'>Impressum</HeadlineSmall>
                    <ReactMarkdown>{content.replaceAll('\n', '  \n ')}</ReactMarkdown>
                </Column>
            </Card>
        </Stack>
    );
};

export { ImprintScreen };
